import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import SignIn from '../pages/customer/SignIn';
import SecurityLayout from '../layout/SecurityLayout';
import Verify from '../security/Verify'; 
import SignUp from "../pages/customer/SignUp";
import VerifyPage from '../pages/customer/VerifyPage';

const SecurityRoute = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route element={<SecurityLayout/>}>
                    <Route path="/sec/log-in" element={<SignIn />} />
                    <Route path="/sec/create-account" element={<SignUp />} />
                    {/* <Route path="/sec/forgot-password" element={<FgPass />} /> */}
                    <Route path="/sec/verify" element={<VerifyPage />} />
                    <Route path="/sec/verify/:token" element={<Verify/>}/>
                    {/* <Route path="/sec/reset-password/:token" element={<ResetPassword />} /> */}
                </Route>
            </Routes>
        </React.Fragment>
    )
}

export default SecurityRoute